import { RegisterOptions } from 'react-hook-form';
import { ModalStates } from '~/hooks/useModal';

type ChangeNameModalInputRules = {
  name: RegisterOptions;
};

export type ChangeNameFormFields = {
  name: string;
}

export type ChangeNameModalProps = {
  onClose: () => void;
  modalState: ModalStates;
  onNameUpdated: (successful : boolean) => void;
};

export const editProfileModalInputRules: ChangeNameModalInputRules = {
  name: {
    required: 'Required field',
    minLength: {
      value: 2,
      message: 'Name must contain min 2 and max 50 characters',
    },
    maxLength: {
      value: 50,
      message: 'Name must contain min 2 and max 50 characters',
    },
  },
};

export const defaultFieldValues: ChangeNameFormFields = {
  name: '',
};
